import { MmsOutlined, SvgIconComponent } from "@mui/icons-material";
import ScheduleIcon from "@mui/icons-material/Schedule";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import { Mode } from "@store/homeSlice";

export interface MenuItem {
  id?: string;
  title: string;
  icon: SvgIconComponent;
  path: string;
  children?: MenuItem[];
  exact?: boolean;
}

const CaregiverMenu: MenuItem[] = [
  {
    id: "menu-dashboard",
    path: "/",
    title: "sideBar.home",
    icon: DashboardOutlinedIcon,
    exact: true,
  },
  {
    id: "menu-companions",
    path: "/companions",
    title: "sideBar.companion",
    icon: PermIdentityOutlinedIcon,
  },
  {
    id: "menu-memories-gallery",
    path: "/gallery",
    title: "sideBar.memoriesGallery",
    icon: MmsOutlined,
  },
  {
    id: "menu-schedule",
    path: "/schedule",
    title: "sideBar.schedule",
    icon: ScheduleIcon,
  },
  {
    id: "menu-transcripts",
    path: "/transcripts",
    title: "sideBar.transcripts",
    icon: TextSnippetOutlinedIcon,
  },
  {
    id: "menu-games",
    path: "/games",
    title: "sideBar.games",
    icon: PsychologyOutlinedIcon,
  },
];

const PatientMenu: MenuItem[] = [
  {
    id: "menu-portal",
    path: "/portal",
    title: "sideBar.patient.home",
    icon: DashboardOutlinedIcon,
    exact: true,
  },
  {
    id: "menu-talk",
    path: "/talk",
    title: "sideBar.patient.talk",
    icon: ChatBubbleOutlineOutlinedIcon,
  },
  {
    id: "menu-gallery",
    path: "/portal/gallery",
    title: "sideBar.patient.memoriesGallery",
    icon: MmsOutlined,
  },
  {
    id: "menu-schedule",
    path: "/portal/schedule",
    title: "sideBar.patient.schedule",
    icon: ScheduleIcon,
  },
  {
    id: "menu-games",
    path: "/portal/games",
    title: "sideBar.patient.games",
    icon: PsychologyOutlinedIcon,
  },
];

const Menu = {
  [Mode.Caregiver]: CaregiverMenu,
  [Mode.Patient]: PatientMenu,
};

export default Menu;
